/* Responsibility: Create the namespaces for FINN.travel */
window.FINN = window.FINN || {};
window.FINN.travel = FINN.travel || {};
window.FINN.travel.pp = window.FINN.travel.pp || {};
window.FINN.travel.contextPath = window.FINN.travel.contextPath || '';
